import { READING_FONT_MAP } from '@/lib/reading-fonts';

const loaded = new Set(['inter']);

export function loadFont(fontKey) {
  if (loaded.has(fontKey)) return Promise.resolve();

  const font = READING_FONT_MAP[fontKey];
  if (!font?.googleFamily) return Promise.resolve();

  const id = `gf-${fontKey}`;
  if (document.getElementById(id)) {
    loaded.add(fontKey);
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${font.googleFamily}:wght@400;700&subset=latin&display=swap`;
    link.onload = () => {
      loaded.add(fontKey);
      resolve();
    };
    link.onerror = resolve;
    document.head.appendChild(link);
  });
}
